import SubtractButton from "./SubtractButton";

export default {
    button: SubtractButton,
    name: "subtract",
};
